export interface IVarianceRequest {
  journalEventIds?: string[];
  userIds?: string[];
  varianceUserIds?: string[];
}
export interface IVarianceResponse {
  id: string;
  entityId: string;
  entity: any;
  amount: number;
  userId: string;
  user: any;
  varianceUserId: string;
  varianceUser: any;
  comment: string;
  createdAt: string;
  updatedAt: string;
}
export interface IVarianceCreateRequest {
  journalCloseEventId: string;
  amount: number;
  varianceUserId: string;
  comment: string;
}

export interface IVariancePaginatedResponse {
  items: IVarianceResponse[];
}
